import { TempTask } from "../model";
import { ITask } from "../shared/db";

export function switchIndex<T>(list: T[], sourceIndex: number, destinationIndex: number): T[] {
  const newList = [...list];
  const sourceItem = newList[sourceIndex];
  const destinationItem = newList[destinationIndex];
  newList[sourceIndex] = destinationItem;
  newList[destinationIndex] = sourceItem;
  return newList;
}

export function reorderByPartialItems<T, R>(
  list: T[],
  items: R[],
  predicate: (a: T, b: R) => boolean,
): T[] {
  const sourceIndices = items.map((item) => list.findIndex((i) => predicate(i, item)));
  const destinationIndices = [...sourceIndices].sort((a, b) => a - b);

  const currentPositions = sourceIndices.reduce<Record<number, number>>((acc, curr, idx) => {
    acc[idx] = curr;
    return acc;
  }, {});

  let reordered = [...list];
  for (let i = 0; i < sourceIndices.length; i++) {
    const currentSourceIndex = currentPositions[i];
    const destinationIndex = destinationIndices[i];

    if (currentSourceIndex !== destinationIndex) {
      reordered = switchIndex(reordered, currentSourceIndex, destinationIndex);

      for (let j = 0; j < sourceIndices.length; j++) {
        if (currentPositions[j] === currentSourceIndex) {
          currentPositions[j] = destinationIndex;
        } else if (currentPositions[j] === destinationIndex) {
          currentPositions[j] = currentSourceIndex;
        }
      }
    }
  }

  return reordered;
}

interface Droppable {
  droppableId: string;
  index: number;
}

interface DropResult {
  source: Droppable;
  destination?: Droppable;
}

export function reorderByDropResult<T>(list: T[], { source, destination }: DropResult): T[] {
  const result = [...list];
  if (
    !destination ||
    (destination.droppableId === source.droppableId && destination.index === source.index)
  ) {
    return result;
  }

  result.splice(destination.index, 0, result.splice(source.index, 1)[0]);
  return result;
}
